

export const API_CONFIG = {
    // Auth0 Configuration
    AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE,

    // Backend API Configuration
    BASE_URL: import.meta.env.VITE_API_BASE_URL,

    // API Endpoints
    ENDPOINTS: {
        AUTH_EXCHANGE: `/api/auth/exchange`,
        CAMPAIGN: `/api/user/campaign`,
        SUPP_DATA: '/api/user/supp-data',
        LLM_MODEL: '/api/user/llm-models',
        WEBCHAT: '/api/user/webchat',
        TRANS_MASTER: '/api/user/trans-master',
        TRANS_MASTER_FILTER: '/api/user/trans-master/filter',
        TRANS_MASTER_RECIPIENTS: '/api/user/trans-master/recipients',
        SUPP_DATA_TYPES: '/api/user/supp-data/types',
        TEMP_JOB_ORDER: '/api/user/temp/job-order',
        TEMP_CANDIDATE: '/api/user/temp/candidate',
        TEMP_TPMO_START_JOB: '/api/user/temp-tpmo/startJobOrder',
        TEMP_TPMO_UPDATE_PHONE: '/api/user/temp-tpmo/updatePhoneNo',
        TEMP_TPMO_VIEW_SQS: '/api/user/temp-tpmo/viewSQS',
        SENDER_PERSONA: '/api/user/sender-persona',
        COUNTRIES_LIST: '/api/user/data/countries',
        COMPLIANCE_COUNTRIES: '/api/user/admin/countries',
        KNOWLEDGE_BASE_INFO: '/api/user/kb-info',
        S3_URL: '/api/user/s3',
        ANALYTICS_TRANSACTION_URL: '/api/user/analytics',
        COMMUNICATION_INTEGRATION: '/api/user/comm',
        COMMUNICATION_SEARCH: '/api/user/comm/search',
        INTEGRATION_CONFIG: '/api/user/config',
        SOR_LOOKUP: '/api/user/sor/lookup',
        ADMIN_ROLES: '/api/user/admin/roles',
        ADMIN_AUTHORITIES: '/api/user/admin/authorities',
        ADMIN_CONSTANT_MESSAGES: '/api/user/admin/constant-messages'
    },
} as const;